export default __webpack_public_path__ + "static/media/odia.42801cab.svg";